import React, { useState } from "react";
import { Spin } from "antd";
import InputFactory from "../../../../components/InputFactory";
import { convertFlatStringFactory } from "../helper-payroll/HelperFunction";
import FormFactory from "../../../../components/FormFactory";
import {
  formatCurrency,
  formatNumber,
} from "../../../../components/common/Converter";
// import "./TablePayroll.css";
import tableStyles from "./TablePayrollStyle";
import {
  shouldRenderInput,
  getValueOrDefault,
  shouldRenderDaterange,
  shouldBeFormatted,
  shouldRenderMultipleInputs,
  shouldFormatArray,
} from "./render-conditions/PayrollRenderingRules";

const TablePayroll = (props) => {
  const {
    tableHeader = [],
    primarySubHdr = [],
    secondarySubHdr = [],
    object = [],
    tfootObjects = {},
    headersKey = [],
    value = [],
    onChange = () => {},
    onclickAction = () => {},
    schema = {},
    selectedTypes = {},
    isLoading = false,
    isColumShow = false,
    styles = {},
    isValueOnly = false,
    isActive = true,
    sortByLastname = true,
    startIndex = 0,
  } = props;

  console.log("TablePayroll received startIndex:", startIndex);
  
  const isAPType = selectedTypes?.payrollTypes === "AP";
  const isBasicGP =
    selectedTypes?.payrollTypes === "BP" &&
    selectedTypes?.jobTypeVal !== "Job Order" &&
    selectedTypes?.payItems === "General Payroll";

  const sortedObject = object
    .map((item, originalIndex) => ({
      ...item,
      originalIndex,
    }))
    .sort((a, b) => {
      const getNetValue = (item) =>
        parseFloat(item["netPay"] ?? item["netAmount"]);

      const isRowLightRed = (item) => {
        const netValue = getNetValue(item);
        if (isAPType) return !isNaN(netValue) && netValue < 0;
        return !isNaN(netValue) && netValue < 5000;
      };

      // if (sortByLastname) {
      //   return a.ln.localeCompare(b.ln, undefined, { sensitivity: "base" });
      // }

      if (sortByLastname) {
        // 1. Compare LN
        const lnCompare = a.ln.localeCompare(b.ln, undefined, {
          sensitivity: "base",
        });
        if (lnCompare !== 0) return lnCompare;

        // 2. Compare FN if LN is same
        const fnCompare = a.fn.localeCompare(b.fn, undefined, {
          sensitivity: "base",
        });
        if (fnCompare !== 0) return fnCompare;

        // 3. Compare MN if FN is also same
        const mnCompare = a.mn.localeCompare(b.mn, undefined, {
          sensitivity: "base",
        });
        if (mnCompare !== 0) return mnCompare;

        // 4. Preserve original row order if completely same
        return a.originalIndex - b.originalIndex;
      }

      return isRowLightRed(b) - isRowLightRed(a);
    });

  const isZeroFieldLabel = new Set([
    "overpaymentBasic",
    "overpaymentPeraAda",
    "overpayment",
    "flagRaising",
    "3",
    "2",
    "5",
    "10",
  ]);
  const excludedLabels = [
    "dateOfAbsences",
    "leaveWithoutPayDates",
    "dateOfHalfDays",
    "daysToBeDeducted",
    "halfDaysToBeDeducted",
    "minutesToBeDeducted",
  ];
  const filteredHeadersKey = isColumShow
    ? [
        { label: "" },
        ...headersKey.filter(({ label }) => {
          if (!label || excludedLabels.includes(label)) {
            return false;
          }

          return object.some((item) => {
            const value = item[label];

            const isZeroArray =
              Array.isArray(value) && value.every((v) => v === 0);
            const isZeroField =
              isZeroFieldLabel.has(label) && (value === 0 || value === "0");

            return (
              value != null && value !== "" && !isZeroArray && !isZeroField
            );
          });
        }),
      ]
    : headersKey;

  // console.log("headersKey", headersKey);

  const groupMap = {};
  let currentIndex = 0;

  for (const header of tableHeader) {
    if (header.colSpan) {
      groupMap[header.label] = primarySubHdr.slice(
        currentIndex,
        currentIndex + header.colSpan
      );
      currentIndex += header.colSpan;
    }
  }

  const convertFlatString_1 = convertFlatStringFactory();

  const getFilteredGroupCount = (groupLabels) => {
    return groupLabels.filter((label) => {
      const toCamelCase = convertFlatString_1(label);

      return filteredHeadersKey.some((f) => f.label === toCamelCase);
    }).length;
  };

  const convertFlatString_2 = convertFlatStringFactory();

  const updatedTableHeader = isColumShow
    ? tableHeader
        .map((header) => {
          if (header.colSpan && groupMap[header.label]) {
            const count = getFilteredGroupCount(groupMap[header.label]);
            return count > 0 ? { ...header, colSpan: count } : null;
          }

          const toCamelCase = convertFlatString_2(header.label);
          const labelMatch = filteredHeadersKey.some(
            (f) => f.label === toCamelCase
          );
          return header.rowSpan || labelMatch ? header : null;
        })
        .filter(Boolean)
    : tableHeader;

  const convertFlatString_3 = convertFlatStringFactory();

  const filteredPrimarySubHdr = isColumShow
    ? primarySubHdr.filter((item) => {
        const convertedLabels = convertFlatString_3(item);
        return filteredHeadersKey.find((key) => key.label === convertedLabels);
      })
    : primarySubHdr;

  let primarySubhdrIndex = 0;

  const convertFlatString_4 = convertFlatStringFactory();
  // const convertFlatString_5 = convertFlatStringFactory();
  const filteredTableHeader = isColumShow
    ? updatedTableHeader
        .map((item) => {
          const camelLabel = convertFlatString_4(item.label);

          if (item.colSpan) {
            const originalSubHeaders = filteredPrimarySubHdr.slice(
              primarySubhdrIndex,
              primarySubhdrIndex + item.colSpan
            );

            primarySubhdrIndex += item.colSpan;

            if (originalSubHeaders.length === 0) return null;

            return {
              ...item,
              colSpan: originalSubHeaders.length,
            };
          }

          const hasData = filteredHeadersKey.some(
            (key) => key.label === camelLabel
          );
          return hasData ? item : null;
        })
        .filter(Boolean)
    : tableHeader;

  const convertFlatString_5 = convertFlatStringFactory();
  const filteredSecondarySubHdr = isColumShow
    ? secondarySubHdr.filter((item) => {
        const convertedItem = convertFlatString_5(item);

        return filteredHeadersKey.find((key) => key.label === convertedItem);
      })
    : secondarySubHdr;

  const hasColSpan = tableHeader.some((header) => "colSpan" in header);
  const headerCount = tableHeader.reduce(
    (count, header) => {
      return count + (header.colSpan || 0);
    },
    hasColSpan ? tableHeader.length - 1 : tableHeader.length
  );

  return (
    <>
      <style>{`
    .custom-scrollbar::-webkit-scrollbar {
      height: 8px;
      background-color: rgb(241, 241, 241);
    }
    .custom-scrollbar::-webkit-scrollbar-thumb {
      background-color: rgb(161, 161, 161);
      border-radius: 4px;
    }
  `}</style>
      <div
        className="custom-scrollbar"
        style={{
          ...tableStyles.scrollContainer,
          ...(styles?.scrollContainer || {}),
        }}
      >
        <table
          className={isColumShow ? "" : "table table-hover"}
          style={{ ...tableStyles.table, ...(styles?.table || {}) }}
        >
          <thead
            className={isActive ? "table-active" : ""}
            style={{ ...tableStyles.active, ...(styles?.active || {}) }}
          >
            <tr
              className={isActive ? "table-active" : ""}
              style={{ ...tableStyles.active, ...(styles?.active || {}) }}
            >
              {filteredTableHeader.map((item, index) => (
                <th
                  style={
                    item.label === "PERIOD COVERED"
                      ? {
                          ...tableStyles.dateHdrCell,
                          ...(styles?.dateHdrCell || {}),
                        }
                      : {
                          ...tableStyles.headerCell,
                          ...(styles?.headerCell || {}),
                        }
                  }
                  key={index}
                  colSpan={item.colSpan}
                  rowSpan={item.rowSpan}
                >
                  {item.label}
                </th>
              ))}
            </tr>
            <tr>
              {filteredPrimarySubHdr.map((header, index) => (
                <th
                  style={
                    header === "DATE"
                      ? {
                          ...tableStyles.dateHdrCell,
                          ...(styles?.dateHdrCell || {}),
                        }
                      : {
                          ...tableStyles.headerCell,
                          ...(styles?.headerCell || {}),
                        }
                  }
                  key={index}
                  colSpan={
                    typeof header === "object" && header.colSpan
                      ? header.colSpan
                      : 1
                  }
                  rowSpan={
                    typeof header === "object" && header.rowSpan
                      ? header.rowSpan
                      : 1
                  }
                >
                  {typeof header === "object" ? header.label : header}
                </th>
              ))}
            </tr>
            <tr>
              {filteredSecondarySubHdr.map((label, index) => (
                <th
                  style={{
                    ...tableStyles.headerCell,
                    ...(styles?.headerCell || {}),
                  }}
                  key={index}
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={headerCount}>
                  <div
                    style={{
                      ...tableStyles.spinContainer,
                      ...(styles?.spinContainer || {}),
                    }}
                  >
                    <Spin size="large" />
                  </div>
                </td>
              </tr>
            ) : sortedObject.length > 0 ? (
              sortedObject.map((item, index) => {
                const originalIndex = item.originalIndex;

                const netValue = parseFloat(
                  item["netPay"] ?? item["netAmount"]
                );
                const isLowNetPay =
                  isBasicGP && !isNaN(netValue) && netValue < 5000;

                const isNegativeAP =
                  !isLowNetPay && !isNaN(netValue) && netValue < 0;

                const rowStyle =
                  isNegativeAP || isLowNetPay
                    ? { backgroundColor: "#ffebeb" }
                    : {};
                return (
                  <tr
                    key={index}
                    style={{
                      ...tableStyles.tr,
                      ...(styles?.tr || {}),
                    }}
                  >
                    {/* <td>{index}</td> */}
                    {filteredHeadersKey.map((key, idx) => (
                      <td
                        style={{
                          ...tableStyles.td,
                          ...(styles?.td || {}),
                          ...rowStyle,
                        }}
                        key={idx}
                      >
                        {shouldRenderInput(key.label, selectedTypes, item) ? (
                          isValueOnly ? (
                            getValueOrDefault(
                              value?.[originalIndex]?.[key.label],
                              key.label,
                              item
                            )
                          ) : (
                            <InputFactory
                              type="String"
                              value={formatNumber(
                                getValueOrDefault(
                                  value?.[originalIndex]?.[key.label],
                                  key.label,
                                  item
                                )
                              )}
                              onChange={(val) => {
                                const cleaned = val.replace(/,/g, "");

                                onChange(
                                  cleaned,
                                  originalIndex,
                                  key.label,
                                  item["id"]
                                );
                              }}
                              onBlur={(e) => {
                                const formatted = formatNumber(e.target.value);
                                const convertBackToNum = parseFloat(
                                  formatted.replace(/,/g, "")
                                );

                                onChange(
                                  isNaN(convertBackToNum)
                                    ? ""
                                    : convertBackToNum,
                                  originalIndex,
                                  key.label,
                                  item["id"]
                                );
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.target.blur();
                                }
                              }}
                            />
                          )
                        ) : shouldRenderDaterange(key.label, selectedTypes) ? (
                          <FormFactory
                            schema={schema}
                            onChange={(value) =>
                              onChange(value, index, key.label, item["id"])
                            }
                            required={false}
                            excludeFields={
                              schema?.fields
                                ? Object.keys(schema.fields).filter(
                                    (key) => key !== "dateRange"
                                  )
                                : []
                            }
                            onclickAction={(value) =>
                              onclickAction(value, index, key.label)
                            }
                          />
                        ) : key.label?.trim() === "" ? (
                          startIndex + index + 1
                        ) : key.label === "absencesMins" ? (
                          formatCurrency((item["absencesMins"] ?? 0).toString())
                        ) : shouldBeFormatted(key.label, item[key.label]) ? (
                          formatCurrency(item[key.label].toString())
                        ) : Array.isArray(item[key.label]) ? (
                          shouldRenderMultipleInputs(
                            key.label,
                            selectedTypes
                          ) ? (
                            <div
                              style={{
                                ...tableStyles.inputContainer,
                                ...(styles?.inputContainer || {}),
                              }}
                            >
                              {item[key.label].map((val, i) =>
                                isValueOnly ? (
                                  <span key={i} style={tableStyles.spanArr}>
                                    {value?.[index]?.[key.label]?.[i] ??
                                      (key.label === "noOfDays" ||
                                      key.label ===
                                        "OfDutyForCiaMciaBinocRangeTo1519"
                                        ? 22
                                        : key.label === "apRate"
                                        ? item["payCode"]
                                        : "")}
                                  </span>
                                ) : (
                                  <InputFactory
                                    key={i}
                                    type="String"
                                    value={formatNumber(
                                      value?.[index]?.[key.label]?.[i] ??
                                        (key.label === "noOfDays" ||
                                        key.label ===
                                          "OfDutyForCiaMciaBinocRangeTo1519"
                                          ? "22"
                                          : key.label === "apRate"
                                          ? item["payCode"]
                                          : "")
                                    )}
                                    onChange={(inputVal) => {
                                      const cleaned = inputVal.replace(
                                        /,/g,
                                        ""
                                      );

                                      // if (isNaN(cleaned)) return;

                                      const numericValue = parseFloat(cleaned);

                                      const targetLength =
                                        item[key.label]?.length ?? 0;
                                      const currentArray =
                                        value?.[index]?.[key.label] ?? [];

                                      // Create a new array preserving existing values
                                      const updatedArray = Array.from(
                                        { length: targetLength },
                                        (_, idx) =>
                                          currentArray[idx] ??
                                          (key.label === "noOfDays" ||
                                          key.label ===
                                            "OfDutyForCiaMciaBinocRangeTo1519"
                                            ? "22"
                                            : key.label === "apRate"
                                            ? item["payCode"]
                                            : "")
                                      );

                                      updatedArray[i] = cleaned; // store as number

                                      onChange(
                                        updatedArray,
                                        index,
                                        key.label,
                                        item["id"]
                                      );
                                    }}
                                    onBlur={(e) => {
                                      const cleaned = e.target.value.replace(
                                        /,/g,
                                        ""
                                      );
                                      const numericValue = parseFloat(cleaned);

                                      if (isNaN(numericValue)) return;

                                      const targetLength =
                                        item[key.label]?.length ?? 0;
                                      const currentArray =
                                        value?.[index]?.[key.label] ?? [];

                                      const updatedArray = Array.from(
                                        { length: targetLength },
                                        (_, idx) =>
                                          currentArray[idx] ??
                                          (key.label === "noOfDays" ||
                                          key.label ===
                                            "OfDutyForCiaMciaBinocRangeTo1519"
                                            ? "22"
                                            : key.label === "apRate"
                                            ? item["payCode"]
                                            : "")
                                      );

                                      updatedArray[i] = numericValue;
                                      onChange(
                                        updatedArray,
                                        index,
                                        key.label,
                                        item["id"]
                                      );
                                    }}
                                  />
                                )
                              )}
                            </div>
                          ) : (
                            <div
                              style={{
                                ...tableStyles.inputContainer,
                                ...(styles?.inputContainer || {}),
                              }}
                            >
                              {item[key.label].map((val, i) => (
                                <span key={i}>
                                  {shouldFormatArray(key.label, val)
                                    ? formatCurrency(val.toString() ?? 0)
                                    : val}
                                </span>
                              ))}
                            </div>
                          )
                        ) : (
                          item[key.label]
                        )}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={headerCount}>
                  <div
                    style={{
                      ...tableStyles.imgContainer,
                      ...(styles?.imgContainer || {}),
                    }}
                  >
                    <img
                      style={{ ...tableStyles.img, ...(styles?.img || {}) }}
                      src={"/noData.svg"}
                      alt="No Data"
                    />
                  </div>
                  <p
                    style={{
                      ...tableStyles.noDataLbl,
                      ...(styles?.noDataLbl || {}),
                    }}
                  >
                    No Data
                  </p>
                </td>
              </tr>
            )}
          </tbody>
          <tfoot style={{ ...tableStyles.tfoot, ...(styles?.tfoot || {}) }}>
            <tr>
              {filteredHeadersKey.map((key, index) => {
                const label = key.label;

                if (index === 0) {
                  return (
                    <td
                      style={{
                        ...tableStyles.tfootTabledata,
                        ...(styles?.tfootTabledata || {}),
                      }}
                      key={label}
                    >
                      Total
                    </td>
                  );
                }

                const value = tfootObjects[label];

                return (
                  <td
                    key={label}
                    style={{
                      ...tableStyles.tfootTabledata,
                      ...(styles?.tfootTabledata || {}),
                    }}
                  >
                    {formatCurrency(
                      (value !== undefined ? value : "").toString()
                    )}
                  </td>
                );
              })}
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );
};

export default TablePayroll;
